var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{attrs:{"type":"checkbox","data-id":"select-all"},on:{"click":function($event){return _vm.list.toggleSelectAll()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }